<template>
  <div class="DetailRichText">
    <div class="title">更多内容</div>
<!--    <detail-title-bar :data="data"/>-->
<!--    <div id="detail-content" :class="off ? 'content' : 'content off'" v-html="data.content"></div>-->
    <div id="detail-content" class="content" v-html="data.content"></div>
<!--    <div v-show="!off" class="btn" @click="off = 1">更多</div>-->
<!--    <div v-show="off" class="btn" @click="off = 0">收起</div>-->
  </div>
</template>

<script>
import DetailTitleBar from "@/views/meetings/detail/DetailTitleBar";
export default {
  name: "DetailRichText",
  components: {DetailTitleBar},
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      off: 0
    }
  }
}
</script>
<style>
#detail-content img {
  max-width: 100%;
}
</style>
<style lang="scss" scoped>
::v-deep {
  #detail-content {
    width: 100%;
    overflow: hidden;
    img {
      max-width: 100%;
    }
  }
  img {
    max-width: 100%;
  }
}
.DetailRichText {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  padding: 0 25px;
  padding-bottom: 70px;
  position: relative;
  margin-top: 20px;
  border-bottom: 1px solid #ECECEC;
  .off {
    height: 110px;
    overflow: hidden;
  }
  .btn {
    background: #ECECEC;
    width: 80px;
    height: 50px;
    font-size: 22px;
    color: #00476C;
    text-align: center;
    line-height: 50px;
    position: absolute;
    right: 25px;
    bottom: 10px;
  }
  .content {
    margin-top: 40px;
    color: #333333;
    font-size: 28px;
  }
  .title {
    text-align: left;
    font-size: 34px;
    color: #00476C;
    font-weight: 600;
  }
  img {
    max-width: 100%;
  }
}
</style>
